import { render, staticRenderFns } from "./EdTelegramDestination.vue?vue&type=template&id=ce3405c8&"
import script from "./EdTelegramDestination.vue?vue&type=script&lang=js&"
export * from "./EdTelegramDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports